import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TaskService } from 'src/app/services/task.service';
import { NcdtermsheetService } from 'src/app/services/NCD/ncdtermsheet.service';
import * as _ from 'lodash';
import * as moment from 'moment'
import { Enums } from 'src/app/helpers/enums';
import { EditTermsheetComponent } from '../edit-termsheet/edit-termsheet.component';
import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'app-termsheet',
  templateUrl: './termsheet.component.html',
  styleUrls: ['./termsheet.component.css']
})
export class TermsheetComponent implements OnInit {

  @Input('issueDetails') issueDetails: any;
  @Output('showTermSheetTabActive') showTermSheetTabActive = new EventEmitter();

  termsheetDataListArray: any = [];
  termSheetDataListArrayCache: any = [];
  listOfValuesArray: any = [];
  dropdownList: any = [];
  issueIdToEdit: any;

  termSheetForm: FormGroup;

  seniority: any = Enums.NCDLibraryFieldName.seniority;
  modeOfIssue: any = Enums.NCDLibraryFieldName.modeOfIssue;
  eligibleInvestors: any = Enums.NCDLibraryFieldName.eligibleInvestors;
  biddingType: any = Enums.NCDLibraryFieldName.biddingType;
  allocationMethod: any = Enums.NCDLibraryFieldName.allocationMethod;
  settlementmethod: any = Enums.NCDLibraryFieldName.settlementmethod;
  listing: any = Enums.NCDLibraryFieldName.listing;
  ObjectsOfIssue: any = Enums.NCDLibraryFieldName.ObjectsOfIssue;
  detailsOfUtilization: any = Enums.NCDLibraryFieldName.detailsOfUtilization;

  keys: any;
  partA: any = [];
  partB: any = [];
  partC: any = [];
  checkersList: any = [];
  checkersDetailArray: any = [];
  issueName: any;

  // MULTI-OPTION
  tenorArray: any = [];
  couponRateArray: any = [];
  couponTypeArray: any = [];
  redemptionPremiumDiscountArray: any = [];
  redemptionAmountArray: any = [];
  issuePriceOrFaceValueArray: any = [];
  // faceValueArray: any = [];
  payinDateArray: any = [];
  redemptionDateArray: any = [];
  disabledOnClick: boolean = false;
  constructor(private ncdTermsheetService: NcdtermsheetService, private taskService: TaskService,
    private modalService: NgbModal, private alert: AlertComponent, public activeModal: NgbActiveModal) {

  }

  ngOnInit() {

    this.termSheetForm = new FormGroup({
    })

    // //console.log("issueDetails", this.issueDetails);

    this.getIssueSpecificTermsheetDetails();

    this.taskService.getUsersList().subscribe((response) => {
      //console.log("getUsersList=========", response);
      // this.checkersList = response.result
      // Dummy onward
      var self = this;
      _.forEach(response.result, function (element) {
        var userName = element.FirstName + " " + element.LastName;
        if (userName == "Dinesh kumbhare") {
          self.checkersList.push({
            userName: userName,
            govevaUserId: element._id,
            email: element.EmailId,
            phone: element.MobileNumber,
            status: true
          });
        } else {
          self.checkersList.push({
            userName: userName,
            govevaUserId: element._id,
            email: element.EmailId,
            phone: element.MobileNumber,
            status: false,
          });
        }
      })
      //console.log("getUsersList=========", self.checkersList);
    })
  }

  addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  getIssueSpecificTermsheetDetails() {
    var self = this;
    this.partA = this.issueDetails.PartA;
    this.partB = this.issueDetails.PartB;

    this.issueName = this.issueDetails.IssueSeries;

    if (!_.isNil(this.issueDetails._id)) {

      this.ncdTermsheetService.getIssueSpecificTermSheet(this.issueDetails._id).subscribe(termsheetList => {

        // console.log("termsheetList", termsheetList);
        this.partC = termsheetList.termSheetDetails.checker;

        this.issueIdToEdit = termsheetList.termSheetDetails.issueId;

        this.termSheetDataListArrayCache = termsheetList.termSheetDetails.termSheetFieldArray;

        // this.termsheetDataListArray = termsheetList.termSheetDetails ;
        var issueTermSheetFields = termsheetList.termSheetDetails.termSheetFieldArray

        _.remove(issueTermSheetFields, function (element) {
          var fieldName = _.get(element, 'FieldName');

          return (fieldName == Enums.NCDLibraryFieldName.security || fieldName == Enums.NCDLibraryFieldName.redeemability || fieldName == Enums.NCDLibraryFieldName.convertibility || fieldName == Enums.NCDLibraryFieldName.typeOfIssue || fieldName == Enums.NCDLibraryFieldName.interestPaymentrequest)
        })

        _.forEach(issueTermSheetFields, function (element) {
          self.termSheetForm.addControl(element.FieldName, new FormControl())
          self.termSheetForm.addControl(element.DefaultValue, new FormControl())
        })

        _.forEach(issueTermSheetFields, function (element) {
          if (element.InputType == "Date") {
            self.termSheetForm.controls[element.FieldName].setValue(self.transformDate(element.DefaultValue));
            // console.log("element.FieldName ==========", element.FieldName);
            if (element.FieldName == 'Pay-in Date') {
              self.payinDateArray = element.DefaultValue.split(',');

              _.forEach(self.payinDateArray, function (payinDateElement, index) {
                let convertIntoNumber = Number(payinDateElement);
                let payinDateConverted = new Date(convertIntoNumber);
                self.payinDateArray[index] = self.transformDate(payinDateConverted);
                // console.log("self.payinDateArray", self.payinDateArray)
              });


            }

            if (element.FieldName == 'Redemption Date') {
              self.redemptionDateArray = element.DefaultValue.split(',');
              self.redemptionDateArray = self.redemptionDateArray.map(function (redemptionDateElement) {
                let convertIntoNumber = Number(redemptionDateElement);
                let redemptionDateConverted = new Date(convertIntoNumber);
                redemptionDateElement = self.transformDate(redemptionDateConverted);
                return redemptionDateElement;
              });
            }
          } else if (element.InputType == "Number") {
            // if (element.FieldName == 'Issue Size') {
            //   let issueSize = element.DefaultValue.replace(/[Crs,]/g, "");
            //   element.DefaultValue = issueSize + ' Crs';
            // }

            // if (element.FieldName == 'Option to retain oversubscription (amount)') {
            //   let OTRO = element.DefaultValue.replace(/[Crs,]/g, "");
            //   element.DefaultValue = OTRO + ' Crs';
            // }

            if (element.FieldName == 'Redemption Amount') {
              self.redemptionAmountArray = element.DefaultValue.split(',');
              _.forEach(self.redemptionAmountArray, function (issuePriceOrFaceValueElement, index) {
                self.redemptionAmountArray[index] = self.addCommas(issuePriceOrFaceValueElement);
              });
            }

            if (element.FieldName == 'Coupon Rate') {
              self.couponRateArray = element.DefaultValue.split(',');
              _.forEach(self.couponRateArray, function (couponRateElement, index) {
                self.couponRateArray[index] = self.addCommas(couponRateElement);
                // console.log("self.couponRateArray", self.couponRateArray)
              });
            }

            if (element.FieldName == 'Issue Price' || element.FieldName == 'Face Value') {
              self.issuePriceOrFaceValueArray = element.DefaultValue.split(',');
              _.forEach(self.issuePriceOrFaceValueArray, function (issuePriceOrFaceValueElement, index) {
                self.issuePriceOrFaceValueArray[index] = self.addCommas(issuePriceOrFaceValueElement);
              });
            }

            self.termSheetForm.controls[element.FieldName].setValue(element.DefaultValue);
          } else {
            self.termSheetForm.controls[element.FieldName].setValue(element.DefaultValue);
            if (element.FieldName == 'Tenor') {
              self.tenorArray = element.DefaultValue.split(',');
            }

            if (element.FieldName == 'Coupon Type') {
              self.couponTypeArray = element.DefaultValue.split(',');
              //console.log("self.tenorArray++++++++++++++++++++++",self.tenorArray)
            }

            if (element.FieldName == 'Redemption Premium / Discount') {
              self.redemptionPremiumDiscountArray = element.DefaultValue.split(',');
              //console.log("self.tenorArray++++++++++++++++++++++",self.tenorArray)
            }

          }
        })

        this.termsheetDataListArray = issueTermSheetFields;
        var count = 0;
        _.forEach(this.termsheetDataListArray, function (fieldList) {
          self.dropdownList[count] = [];
          self.listOfValuesArray = fieldList.ListOfValues;
          for (let i = 0; i < self.listOfValuesArray.length; i++) {
            var valueList = self.listOfValuesArray[i]['newFieldValue' + i]
            self.dropdownList[count].push(valueList);
          }
          count++;
        })

        this.showTermSheetTabActive.emit()

      });



    } else {

      this.termsheetDataListArray = [];


    }
  }


  transformDate(date) {
    if (!_.isNil(date) && date != "") {
      date = new Date(date)
      date = moment(date).format("dddd, MMMM Do YYYY");
    }


    return date;
  }


  editModalForTermSheet(termsheetField) {
    if (termsheetField.systemGenerated == false && termsheetField.FieldName != "Security Name" && termsheetField.FieldName != "Redemption Date" && termsheetField.FieldName != "Issue Opening Date" && termsheetField.FieldName != "Issue Closing Date" && termsheetField.FieldName != "Pay-in Date" && termsheetField.FieldName != "Deemed Date of Allotment" && termsheetField.FieldName != "Rating of the Instrument" && termsheetField.FieldName != "Minimum Application and in multiples of - Debt securities thereafter") {
      const modalRef = this.modalService.open(EditTermsheetComponent, {
        backdrop: 'static',
        size: "lg"
      })

      modalRef.componentInstance.termSheetFieldToEdit = termsheetField;
      modalRef.componentInstance.issueIdToEdit = this.issueIdToEdit;

      modalRef.result.then(resp => {
        this.getIssueSpecificTermsheetDetails();
      }, (error) => {
      })
    } else {
      this.alert.error("Please Update this field from Part A or Part B");
    }
  }

  changeValueFromDropdown(ev, fieldName) {
    this.termSheetForm.controls[fieldName].setValue(ev.target.value);
    for (let i = 0; i < this.termsheetDataListArray.length; i++) {
      if (this.termsheetDataListArray[i].FieldName == fieldName) {
        this.termsheetDataListArray[i].DefaultValue = ev.target.value;
      }
    }
  }

  updateTermsheet() {
    this.disabledOnClick = true;
    var updatedtermsheetObject = {
      issueId: this.issueIdToEdit,
      termSheetFieldArray: this.termsheetDataListArray
    }

    this.ncdTermsheetService.updateGeneratedTermsheet(updatedtermsheetObject).subscribe((updatedTermsheet: any) => {
      console.log("updatedTermsheet ======", updatedTermsheet);
      if (updatedTermsheet.status == 0) {
        this.disabledOnClick = false;
        this.getIssueSpecificTermsheetDetails();
        this.alert.successWithOk(updatedTermsheet.message, '/ncd-issue/edit/' + this.issueIdToEdit)
      } else {
        this.alert.error(updatedTermsheet.message);
      }
    })
  }

  SubmitTermSheetForApprovalByChecker() {
    this.disabledOnClick = true;
    //console.log("this.partC.Checker", this.partC);
    if (this.partC != "") {
      this.checkersDetailArray = [];
      var self = this;
      _.forEach(this.checkersList, function (element) {
        // var isPresent = a.some(function (el) { return el.id === 2 });
        //console.log("element", element);

        if (self.partC.Checker.indexOf(element.govevaUserId) !== -1) {
          // alert("Value exists!")
          var checkersObject = {
            checkerName: element.userName,
            email: element.email,
            phone: element.phone,
            // govevaUserId: element.govevaUserId
          }
          self.checkersDetailArray.push(checkersObject);
        }
      })

      var termsheetApprovalObject = {
        CompanyID: JSON.parse(localStorage.getItem('companyDetails')).companyID,
        CompanyName: JSON.parse(localStorage.getItem('companyDetails')).companyName,
        issueId: self.issueIdToEdit,
        checkers: self.checkersDetailArray,
        makerName: self.partC.Maker,
        makerEmailId: JSON.parse(localStorage.getItem('user')).EmailId,
        issueName: self.issueName,
        status: true
      }
      this.ncdTermsheetService.termSheetApprovalByChecker(termsheetApprovalObject).subscribe(termSheetApproval => {
        this.disabledOnClick = false;
        this.alert.success("Termsheet Send for Approval successfully.");
        // this.getIssueSpecificTermsheetDetails();
      })
    } else {
      this.disabledOnClick = false;
      this.alert.error("Please select atleast one checker from part C.");
    }
  }

  generateTermsheetDoc() {
    this.ncdTermsheetService.generateTermsheetDocument(this.issueIdToEdit).subscribe(response => {
      if (response.status == 0) {
        this.downloadTermsheetDocument();
        this.alert.success("Termsheet Generated successfully.");
      } else {
        this.alert.error("Oops, Something went wrong.")
      }
    })
  }

  downloadTermsheetDocument() {
    this.ncdTermsheetService.downloadTermsheetDocument(this.issueIdToEdit);
  }

}

